import LazyLoad from 'vanilla-lazyload';

const initLazyLoad = new LazyLoad();
initLazyLoad.update();
